/**
 * Table Block Configuration
 *
 * Registry config for the table block type. Uses TipTap's table extension
 * for rich text cells with bold, italic, and link support.
 */

import { Table2 } from "lucide-react";
import { TableBlock } from "@/canvas/components/blocks/TableBlock";
import type { BlockConfig } from "../types";

/**
 * Default TipTap table content: 3 columns, header row + 2 data rows
 */
const defaultTableContent = () => ({
  tiptapContent: {
    type: "doc",
    content: [
      {
        type: "table",
        content: [
          {
            type: "tableRow",
            content: [
              { type: "tableHeader", content: [{ type: "paragraph", content: [] }] },
              { type: "tableHeader", content: [{ type: "paragraph", content: [] }] },
              { type: "tableHeader", content: [{ type: "paragraph", content: [] }] },
            ],
          },
          {
            type: "tableRow",
            content: [
              { type: "tableCell", content: [{ type: "paragraph", content: [] }] },
              { type: "tableCell", content: [{ type: "paragraph", content: [] }] },
              { type: "tableCell", content: [{ type: "paragraph", content: [] }] },
            ],
          },
          {
            type: "tableRow",
            content: [
              { type: "tableCell", content: [{ type: "paragraph", content: [] }] },
              { type: "tableCell", content: [{ type: "paragraph", content: [] }] },
              { type: "tableCell", content: [{ type: "paragraph", content: [] }] },
            ],
          },
        ],
      },
    ],
  },
});

export const tableBlockConfig: BlockConfig<"table"> = {
  type: "table",
  component: TableBlock,
  icon: Table2,
  iconClassName: "text-cyan-600",
  label: "canvas.blockTypes.table",
  defaultContent: defaultTableContent,
};
